module.exports = __webpack_public_path__ + "static/media/W1.7946e6b9.png";